//@ts-ignore
import { FileUpload } from "@careinfo/file-upload-service";
import TabPanel from "../Reusable/Tab";
import EditManifest from "./EditManifest";

const SwitchTab = (props: any) => {
  const {
    handleEdit,
    isLoading,
    data,
    gridData,
    id,
    handleAttachConsignment,
    handleManualAttachConsignment,
    handlePrint,
    isPrintLoading,
    handleStatusChange,
    defaultValue,
    isRemoved,
    handleRemove,
    isAttachLoading,
    handleSplitPrint,
    handleSplit,
    refetch,
  } = props;

  return (
    <>
      <TabPanel
        tabTitle={["Update", "Documents"]}
        tabPanels={[
          <>
            <EditManifest
              handleEdit={handleEdit}
              isLoading={isLoading}
              data={data}
              gridData={gridData}
              id={id}
              handleAttachConsignment={handleAttachConsignment}
              handleManualAttachConsignment={handleManualAttachConsignment}
              handlePrint={handlePrint}
              isPrintLoading={isPrintLoading}
              handleStatusChange={handleStatusChange}
              defaultValue={defaultValue}
              isRemoved={isRemoved}
              handleRemove={handleRemove}
              isAttachLoading={isAttachLoading}
              handleSplitPrint={handleSplitPrint}
              handleSplit={handleSplit}
              refetch={refetch}
            />
          </>,
          <>
            <FileUpload object_id={id} />
          </>,
        ]}
      />
    </>
  );
};

export default SwitchTab;
